import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  usageAnalyticsService,
  type UpdateTenantUsageAnalyticsDto,
} from "../services/usageAnalyticsService";

const KEYS = {
  usageAnalytics: (tenantId: string) =>
    ["tenant-usage-analytics", tenantId] as const,
};

export function useUsageAnalytics(tenantId: string) {
  return useQuery({
    queryKey: KEYS.usageAnalytics(tenantId),
    queryFn: () => usageAnalyticsService.get(tenantId),
    enabled: !!tenantId,
  });
}

export function useUpdateUsageAnalytics(tenantId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: UpdateTenantUsageAnalyticsDto) =>
      usageAnalyticsService.update(tenantId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEYS.usageAnalytics(tenantId) });
    },
  });
}
